import { FC, memo } from "react";
import { Stack, Typography } from "@mui/material";
import { money } from "../../../../../../../../../../../utils/numeral/money";
import { TrendChip } from "../../../../../../../../../../common/chips/TrendChip";

interface ResourceExplorerCostCellProps {
  cost: number | null;
  trend?: number | null;
  trendTooltip?: string;
}

export const ResourceExplorerGranularCostCell: FC<ResourceExplorerCostCellProps> =
  memo(({ cost, trend, trendTooltip }) => {
    return (
      <Stack alignItems="end" justifyContent="center" pr={4.5} spacing={0.25}>
        <Typography variant="body2">
          {cost !== null ? money(cost) : "-"}
        </Typography>

        {trend !== null && (
          <TrendChip value={trend} size="small" tooltipTitle={trendTooltip} />
        )}
      </Stack>
    );
  });
